import React, { useState } from 'react'
import fullImage from '../img/Torky.png'
import { motion, AnimatePresence } from "framer-motion"
import { Icon } from '@iconify/react'
import timelineData from '../data/timeLineData.json'
import { Link } from 'react-router-dom'

const About = ({ language, languageText, darkMode }) => {

    const [activeEvent, setActiveEvent] = useState(null);

    const pageVariant = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 0.5, staggerChildren: 0.08 } },
        exit: { opacity: 0, transition: { duration: 0.2 } }
    };
    const fadeUp = {
        hidden: { opacity: 0, y: 24 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } }
    };

    const contacts = [
        {
            icon: 'mdi:email',
            label: language === 'en' ? 'Email' : 'البريد',
            value: 'mohamed2003torky@gmail.com',
            href: 'mailto:mohamed2003torky@gmail.com',
            color: '#ea4335'
        },
        {
            icon: 'ic:baseline-whatsapp',
            label: language === 'en' ? 'WhatsApp' : 'واتساب',
            value: '+20 155 420 6775',
            href: 'http://wa.me/201554206775',
            color: '#25d366'
        },
        {
            icon: 'mdi:linkedin',
            label: 'LinkedIn',
            value: 'Mohamed Torky',
            href: 'https://www.linkedin.com/in/mohamed-torky-243196221/',
            color: '#0a66c2'
        },
    ];

    const stats = [
        { num: '3.79', sub: language === 'en' ? 'GPA · BSc CS' : 'معدل تراكمي', icon: 'lucide:graduation-cap' },
        { num: '3.82', sub: language === 'en' ? 'GPA · MSc DS' : 'معدل دراسات عليا', icon: 'lucide:brain' },
        { num: '10+', sub: language === 'en' ? 'Projects Built' : 'مشروع مكتمل', icon: 'lucide:folder-code' },
        { num: '1st', sub: language === 'en' ? 'Microsoft Hackathon' : 'هاكاثون مايكروسوفت', icon: 'lucide:trophy' },
    ];

    return (
        <motion.div
            variants={pageVariant}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="w-full min-h-screen bg-[#f4f4fa] dark:bg-[#08080f]"
        >
            {/* ── HERO ─────────────────────────────────────────────────── */}
            <div className="relative overflow-hidden"
                style={{
                    background: 'linear-gradient(135deg, #0a0a18 0%, #0e0e22 60%, #121220 100%)',
                    minHeight: 520
                }}>
                {/* Orbs */}
                <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full opacity-15 blur-[120px] pointer-events-none"
                    style={{ background: 'radial-gradient(circle, #525ceb, transparent)' }} />
                <div className="absolute -bottom-40 -right-40 w-[400px] h-[400px] rounded-full opacity-10 blur-[120px] pointer-events-none"
                    style={{ background: 'radial-gradient(circle, #a855f7, transparent)' }} />
                {/* Dot grid */}
                <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff'%3E%3Ccircle cx='30' cy='30' r='0.8'/%3E%3C/g%3E%3C/svg%3E")` }} />

                <div className="max-w-6xl mx-auto px-4 md:px-10 lg:px-20 py-16 md:py-24 relative z-10">
                    <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">

                        {/* Photo */}
                        <motion.div variants={fadeUp} className="flex-shrink-0">
                            <div className="relative w-52 h-52 md:w-64 md:h-64">
                                {/* Animated ring */}
                                <div className="absolute inset-0 rounded-3xl"
                                    style={{
                                        background: 'linear-gradient(135deg, #525ceb, #a855f7, #10b981)',
                                        padding: 3,
                                        borderRadius: 28,
                                    }}>
                                    <div className="w-full h-full rounded-[22px] overflow-hidden bg-gray-900">
                                        <img src={fullImage} alt="Mohamed Torky"
                                            className="w-full h-full object-cover object-top mix-blend-luminosity opacity-90 hover:opacity-100 hover:mix-blend-normal transition-opacity duration-500" />
                                    </div>
                                </div>
                                {/* Status badge */}
                                <div className="absolute -bottom-3 -right-3 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold text-white"
                                    style={{ background: 'linear-gradient(135deg, #10b981, #06b6d4)', boxShadow: '0 8px 20px rgba(16,185,129,0.4)' }}>
                                    <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
                                    {language === 'en' ? 'Available' : 'متاح'}
                                </div>
                            </div>
                        </motion.div>

                        {/* Text */}
                        <div className={`${language === 'en' ? 'lg:text-left' : 'lg:text-right'} flex-1 text-center`}>
                            <motion.div variants={fadeUp} className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-xs font-black uppercase tracking-widest mb-5"
                                style={{ background: 'rgba(82,92,235,0.15)', color: '#525ceb', border: '1px solid rgba(82,92,235,0.3)' }}>
                                <Icon icon="lucide:sparkles" />
                                {language === 'en' ? 'Torky Studio Founder · Full-Stack Engineer' : 'مؤسس استوديو تركي · مهندس برمجيات'}
                            </motion.div>

                            <motion.h1 variants={fadeUp}
                                className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-4">
                                {language === 'en' ? 'Mohamed' : 'محمد'}{language === 'en' ? <span className="text-gradient">Torky</span> : <span className="text-gradient">تركي</span>}
                            </motion.h1>

                            <motion.p variants={fadeUp}
                                className="text-base md:text-lg text-gray-400 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0 font-medium">
                                {language === 'en'
                                    ? "Founder of Torky Studio and Full-Stack Developer & Data Scientist based in Egypt. I craft high-performance web applications, beautiful user interfaces, and bespoke digital experiences for visionary brands and personal milestones. Recently completed my Master's in Data Science at UTM."
                                    : 'مؤسس استوديو تركي، ومطور ويب متكامل وعالم بيانات من مصر. أقوم ببناء تطبيقات ويب فائقة الأداء، وواجهات مستخدم متقنة، وتجارب رقمية مخصصة للعلامات التجارية والمناسبات المميزة. حاصل على ماجستير في علم البيانات من جامعة UTM.'}
                            </motion.p>

                            {/* Contact links */}
                            <motion.div variants={fadeUp} className="flex flex-wrap gap-3 justify-center lg:justify-start mb-8">
                                {contacts.map((c, i) => (
                                    <Link key={i} to={c.href} target="_blank"
                                        className="flex items-center gap-2 px-4 py-2.5 rounded-xl font-bold text-xs uppercase tracking-wide text-white transition-transform duration-200 hover:scale-105 hover:-translate-y-0.5 active:scale-95"
                                        style={{
                                            background: `${c.color}20`,
                                            border: `1px solid ${c.color}30`,
                                            color: c.color
                                        }}
                                        onMouseEnter={e => { e.currentTarget.style.background = c.color; e.currentTarget.style.color = 'white'; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = `${c.color}20`; e.currentTarget.style.color = c.color; }}
                                    >
                                        <Icon icon={c.icon} className="text-base" />
                                        {c.label}
                                    </Link>
                                ))}
                            </motion.div>

                            {/* CTA buttons */}
                            <motion.div variants={fadeUp} className="flex flex-wrap gap-3 justify-center lg:justify-start">
                                <Link to="/services"
                                    className="flex items-center gap-2 px-6 py-3 rounded-2xl font-black text-sm uppercase tracking-wide text-white transition-transform duration-200 hover:scale-105 active:scale-95"
                                    style={{ background: 'linear-gradient(135deg, #525ceb, #a855f7)', boxShadow: '0 12px 40px rgba(82,92,235,0.35)' }}>
                                    <Icon icon="lucide:briefcase" />
                                    {language === 'en' ? 'Hire Me' : 'وظفني'}
                                </Link>
                                <Link to="/projects"
                                    className="flex items-center gap-2 px-6 py-3 rounded-2xl font-bold text-sm uppercase tracking-wide text-white transition-transform duration-200 hover:scale-105 active:scale-95"
                                    style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}
                                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.12)'}
                                    onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.06)'}
                                >
                                    <Icon icon="lucide:folder-open" />
                                    {language === 'en' ? 'View Work' : 'عرض الأعمال'}
                                </Link>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── STATS STRIP ──────────────────────────────────────────── */}
            <div className="border-b border-gray-100 dark:border-white/5"
                style={{ background: 'rgba(255,255,255,0.03)' }}>
                <div className="max-w-6xl mx-auto px-4 md:px-10 lg:px-20">
                    <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-gray-100 dark:divide-white/5">
                        {stats.map((s, i) => (
                            <motion.div key={i} variants={fadeUp}
                                className="flex flex-col items-center py-8 px-4 text-center">
                                <div className="w-10 h-10 rounded-xl mb-3 flex items-center justify-center"
                                    style={{ background: 'rgba(82,92,235,0.1)', color: '#525ceb' }}>
                                    <Icon icon={s.icon} className="text-lg" />
                                </div>
                                <div className="text-2xl md:text-3xl font-black text-gradient mb-1">{s.num}</div>
                                <div className="text-[10px] text-gray-400 font-bold uppercase tracking-widest leading-snug">{s.sub}</div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── ABOUT TORKY STUDIO CARD ───────────────────────────────── */}
            <div className="max-w-6xl mx-auto px-4 md:px-10 lg:px-20 pt-16 md:pt-20">
                <motion.div variants={fadeUp}
                    className="p-8 md:p-12 rounded-3xl relative overflow-hidden bg-white/80 dark:bg-[#0c0d1b]/90 border border-slate-200/80 dark:border-white/10 shadow-xl dark:shadow-2xl backdrop-blur-md"
                >
                    {/* Subtle ambient light */}
                    <div className="absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl opacity-15 dark:opacity-25 pointer-events-none"
                        style={{ background: 'radial-gradient(circle, #00d2ff, #525ceb)' }} />
                    <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full blur-3xl opacity-10 dark:opacity-20 pointer-events-none"
                        style={{ background: 'radial-gradient(circle, #38bdf8, transparent)' }} />

                    <div className="relative z-10 flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12">
                        {/* Emblem */}
                        <div className="relative flex-shrink-0 flex items-center justify-center">
                            <motion.div
                                whileHover={{ scale: 1.05 }}
                                transition={{ type: 'spring', stiffness: 260, damping: 20 }}
                                className="relative w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 rounded-2xl p-2.5 bg-slate-950 shadow-xl border border-cyan-500/30 flex items-center justify-center overflow-hidden group cursor-pointer"
                            >
                                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 via-transparent to-blue-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                <img
                                    src="/TS.png"
                                    alt="Torky Studio Emblem"
                                    className="w-full h-full object-contain rounded-xl"
                                />
                            </motion.div>
                        </div>

                        {/* Content */}
                        <div className="flex-1 text-center md:text-start">
                            <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full text-xs font-black uppercase tracking-wider mb-4 w-fit mx-auto md:mx-0 bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 border border-cyan-500/25">
                                <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulse" />
                                {language === 'en' ? 'The Studio & Creative Practice' : 'الاستوديو والرؤية الإبداعية'}
                            </div>

                            <h2 className="text-2xl md:text-3xl font-black text-slate-900 dark:text-white mb-2 leading-tight">
                                <span className="bg-gradient-to-r from-cyan-600 to-blue-600 dark:from-cyan-400 dark:to-blue-400 bg-clip-text text-transparent">
                                    Torky Studio
                                </span>
                                <span className="text-sm md:text-base font-semibold text-slate-500 dark:text-gray-400 block sm:inline sm:ml-3">
                                    {language === 'en' ? '— Digital Design & Web Engineering' : '— التصميم الرقمي وهندسة الويب'}
                                </span>
                            </h2>

                            <p className="text-sm md:text-base text-slate-600 dark:text-gray-300 leading-relaxed max-w-3xl mb-6 font-normal">
                                {language === 'en'
                                    ? "Torky Studio is my independent digital design and software development practice. I partner directly with founders, creators, and couples to bring their online visions to life with high craftsmanship. When you see « Created and designed by Torky Studio » on any web platform, it reflects tailored engineering, zero-bloat modern code, and distinct aesthetic care."
                                    : "استوديو تركي هو معملي المستقل للتصميم الرقمي وتطوير البرمجيات. أتعاون بشكل مباشر مع رواد الأعمال، والمبدعين، والعرائس لتحويل أفكارهم إلى منصات ويب استثنائية. عندما تشاهد توقيع « تم التصميم والتطوير بواسطة استوديو تركي »، فهو دلالة على هندسة مخصصة، كود عصري فائق السرعة، وعناية جمالية مميزة."}
                            </p>

                            {/* Tags */}
                            <div className="flex flex-wrap gap-2 mb-6 justify-center md:justify-start">
                                {[
                                    { label: language === 'en' ? 'Bespoke Web Development' : 'تطوير مواقع مخصصة', icon: 'lucide:code' },
                                    { label: language === 'en' ? 'Event & Wedding Portals' : 'بوابات مناسبات وأفراح', icon: 'lucide:heart' },
                                    { label: language === 'en' ? 'UI/UX & Creative Direction' : 'تصميم واجهات وتجارب تفاعلية', icon: 'lucide:palette' },
                                    { label: language === 'en' ? 'AI & Data Integration' : 'ذكاء اصطناعي وبيانات', icon: 'lucide:cpu' },
                                ].map((tag, idx) => (
                                    <span key={idx} className="inline-flex items-center gap-1.5 px-3 py-1 rounded-xl text-xs font-semibold text-slate-700 dark:text-slate-300 bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10">
                                        <Icon icon={tag.icon} className="text-cyan-500" />
                                        {tag.label}
                                    </span>
                                ))}
                            </div>

                            {/* Buttons */}
                            <div className="flex flex-wrap gap-3 justify-center md:justify-start">
                                <Link to="/services"
                                    className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl font-black text-sm uppercase tracking-wide text-white transition-transform duration-200 hover:scale-105 active:scale-95 shadow-lg shadow-cyan-500/20"
                                    style={{ background: 'linear-gradient(135deg, #0284c7, #00d2ff)' }}>
                                    <Icon icon="lucide:briefcase" className="text-base" />
                                    {language === 'en' ? 'Studio Services' : 'خدمات الاستوديو'}
                                </Link>
                                <Link to="/projects"
                                    className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl font-bold text-sm text-slate-800 dark:text-white uppercase tracking-wide hover:bg-slate-100 dark:hover:bg-white/10 transition-colors duration-200 border border-slate-300 dark:border-white/15">
                                    <Icon icon="lucide:folder-code" className="text-cyan-500" />
                                    {language === 'en' ? 'Client Case Studies' : 'مشاريع العملاء'}
                                </Link>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>

            {/* ── TIMELINE ─────────────────────────────────────────────── */}
            <div className="relative overflow-hidden py-24 md:py-32" style={{ background: 'linear-gradient(180deg, transparent 0%, rgba(82,92,235,0.03) 50%, transparent 100%)' }}>

                {/* Ambient background orbs */}
                <div className="absolute top-1/4 left-0 w-96 h-96 rounded-full opacity-5 blur-[100px] pointer-events-none" style={{ background: 'radial-gradient(circle, #525ceb, transparent)' }} />
                <div className="absolute bottom-1/4 right-0 w-96 h-96 rounded-full opacity-5 blur-[100px] pointer-events-none" style={{ background: 'radial-gradient(circle, #a855f7, transparent)' }} />

                <div className="max-w-5xl mx-auto px-4 md:px-10 lg:px-16">

                    {/* Section header */}
                    <motion.div variants={fadeUp} className={`mb-16 md:mb-24 ${language === 'ar' ? 'text-right' : 'text-left'}`}>
                        <p className="text-[10px] font-black uppercase tracking-[0.3em] mb-4" style={{ color: '#525ceb' }}>
                            {language === 'en' ? '— The Story So Far —' : '— القصة حتى الآن —'}
                        </p>
                        <h2 className="text-4xl md:text-6xl font-black leading-tight mb-4 text-darktheme dark:text-white">
                            {language === 'en' ? 'My Journey' : 'رحلتي'}
                        </h2>
                        <p className="text-sm text-gray-500 font-medium max-w-md" style={{ lineHeight: 1.8 }}>
                            {language === 'en'
                                ? 'Every milestone, every challenge, every breakthrough — a chapter that made me who I am today.'
                                : 'كل محطة، كل تحدٍّ، كل اختراق — فصل صنع مني ما أنا عليه اليوم.'}
                        </p>
                    </motion.div>

                    {/* Timeline */}
                    <div className="relative">

                        {/* Vertical spine line — centered */}
                        <div className="absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2 pointer-events-none"
                            style={{ background: 'linear-gradient(to bottom, transparent, #525ceb 10%, #a855f7 50%, #10b981 90%, transparent)' }} />

                        {/* Timeline items */}
                        <div className="space-y-0">
                            {timelineData.map((item, index) => {
                                const isActive = activeEvent === index;
                                // In LTR: even = left, odd = right. In RTL: mirror it
                                const isLeft = language === 'ar' ? index % 2 !== 0 : index % 2 === 0;
                                const isLast = index === timelineData.length - 1;

                                return (
                                    <motion.div
                                        key={index}
                                        variants={fadeUp}
                                        className="relative grid grid-cols-[1fr_auto_1fr] items-start gap-0"
                                        style={{ marginBottom: isLast ? 0 : '3rem' }}
                                    >
                                        {/* LEFT column */}
                                        <div className={`py-2 ${isLeft ? 'pr-8 lg:pr-12' : ''}`}>
                                            {isLeft && (
                                                <motion.div
                                                    whileHover={{ scale: 1.02, y: -2 }}
                                                    onClick={() => setActiveEvent(isActive ? null : index)}
                                                    className="cursor-pointer rounded-3xl p-5 group relative overflow-hidden ml-auto"
                                                    style={{
                                                        background: isActive
                                                            ? 'linear-gradient(135deg, rgba(82,92,235,0.12) 0%, rgba(168,85,247,0.06) 100%)'
                                                            : darkMode ? 'rgba(255,255,255,0.02)' : 'rgba(255,255,255,0.85)',
                                                        border: isActive ? '1px solid rgba(82,92,235,0.4)' : darkMode ? '1px solid rgba(255,255,255,0.07)' : '1px solid rgba(0,0,0,0.07)',
                                                        boxShadow: isActive ? '0 20px 60px rgba(82,92,235,0.12)' : darkMode ? 'none' : '0 4px 20px rgba(0,0,0,0.05)',
                                                        maxWidth: 400,
                                                        direction: language === 'ar' ? 'rtl' : 'ltr',
                                                        textAlign: language === 'ar' ? 'right' : 'left',
                                                    }}
                                                >
                                                    {/* Shimmer on hover */}
                                                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-500"
                                                        style={{ background: 'linear-gradient(135deg, rgba(82,92,235,0.04) 0%, transparent 60%)' }} />

                                                    <div className="flex items-center gap-2 mb-3" style={{ flexDirection: language === 'ar' ? 'row-reverse' : 'row' }}>
                                                        <span className="text-[9px] font-black uppercase tracking-[0.2em]" style={{ color: '#525ceb' }}>
                                                            {language === 'ar' ? item.arabicDate : item.date}
                                                        </span>
                                                        {isLast && (
                                                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[8px] font-black bg-emerald-500/10 text-emerald-400 border border-emerald-500/20">
                                                                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                                                                {language === 'ar' ? 'الآن' : 'Now'}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <h3 className="text-base font-black text-darktheme dark:text-white leading-snug mb-1 group-hover:text-gradient transition-colors duration-300">
                                                        {language === 'ar' ? item.arabicTitle : item.title}
                                                    </h3>
                                                    <AnimatePresence>
                                                        {isActive && (
                                                            <motion.p
                                                                initial={{ opacity: 0, height: 0 }}
                                                                animate={{ opacity: 1, height: 'auto' }}
                                                                exit={{ opacity: 0, height: 0 }}
                                                                transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                                                                className="text-xs text-gray-400 mt-2 overflow-hidden"
                                                                style={{ lineHeight: 1.7 }}
                                                            >
                                                                {language === 'ar' ? item.arabicDescription : item.description}
                                                            </motion.p>
                                                        )}
                                                    </AnimatePresence>
                                                    <motion.div
                                                        animate={{ rotate: isActive ? 180 : 0 }}
                                                        className="mt-3 flex"
                                                        style={{ justifyContent: language === 'ar' ? 'flex-start' : 'flex-end' }}
                                                    >
                                                        <Icon icon="lucide:chevron-down" className="text-gray-600 text-sm" />
                                                    </motion.div>
                                                </motion.div>
                                            )}
                                        </div>

                                        {/* CENTER spine node */}
                                        <div className="flex flex-col items-center relative z-10" style={{ width: 56 }}>
                                            <motion.button
                                                whileHover={{ scale: 1.15 }}
                                                whileTap={{ scale: 0.95 }}
                                                onClick={() => setActiveEvent(isActive ? null : index)}
                                                className="relative flex items-center justify-center w-12 h-12 rounded-2xl text-white shadow-lg flex-shrink-0"
                                                style={{
                                                    background: isActive
                                                        ? 'linear-gradient(135deg, #525ceb, #a855f7)'
                                                        : darkMode
                                                            ? 'linear-gradient(135deg, rgba(82,92,235,0.35), rgba(168,85,247,0.25))'
                                                            : 'linear-gradient(135deg, rgba(82,92,235,0.8), rgba(168,85,247,0.7))',
                                                    border: darkMode ? '2px solid rgba(255,255,255,0.12)' : '2px solid rgba(82,92,235,0.2)',
                                                    boxShadow: isActive ? '0 0 30px rgba(82,92,235,0.6), 0 8px 24px rgba(82,92,235,0.3)' : '0 4px 16px rgba(82,92,235,0.2)',
                                                    backdropFilter: 'blur(8px)',
                                                }}
                                            >
                                                {/* Pulse ring when active */}
                                                {isActive && (
                                                    <motion.div
                                                        initial={{ scale: 1, opacity: 0.5 }}
                                                        animate={{ scale: 1.8, opacity: 0 }}
                                                        transition={{ duration: 1.2, repeat: Infinity }}
                                                        className="absolute inset-0 rounded-2xl"
                                                        style={{ background: 'rgba(82,92,235,0.4)' }}
                                                    />
                                                )}
                                                <Icon icon={item.icon} className="text-lg relative z-10" />
                                            </motion.button>
                                        </div>

                                        {/* RIGHT column */}
                                        <div className={`py-2 ${!isLeft ? 'pl-8 lg:pl-12' : ''}`}>
                                            {!isLeft && (
                                                <motion.div
                                                    whileHover={{ scale: 1.02, y: -2 }}
                                                    onClick={() => setActiveEvent(isActive ? null : index)}
                                                    className="cursor-pointer rounded-3xl p-5 group relative overflow-hidden mr-auto"
                                                    style={{
                                                        background: isActive
                                                            ? 'linear-gradient(135deg, rgba(82,92,235,0.12) 0%, rgba(168,85,247,0.06) 100%)'
                                                            : darkMode ? 'rgba(255,255,255,0.02)' : 'rgba(255,255,255,0.85)',
                                                        border: isActive ? '1px solid rgba(82,92,235,0.4)' : darkMode ? '1px solid rgba(255,255,255,0.07)' : '1px solid rgba(0,0,0,0.07)',
                                                        boxShadow: isActive ? '0 20px 60px rgba(82,92,235,0.12)' : darkMode ? 'none' : '0 4px 20px rgba(0,0,0,0.05)',
                                                        maxWidth: 400,
                                                        direction: language === 'ar' ? 'rtl' : 'ltr',
                                                        textAlign: language === 'ar' ? 'right' : 'left',
                                                    }}
                                                >
                                                    {/* Shimmer on hover */}
                                                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-500"
                                                        style={{ background: 'linear-gradient(135deg, rgba(82,92,235,0.04) 0%, transparent 60%)' }} />

                                                    <div className="flex items-center gap-2 mb-3" style={{ flexDirection: language === 'ar' ? 'row-reverse' : 'row' }}>
                                                        <span className="text-[9px] font-black uppercase tracking-[0.2em]" style={{ color: '#525ceb' }}>
                                                            {language === 'ar' ? item.arabicDate : item.date}
                                                        </span>
                                                        {isLast && (
                                                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[8px] font-black bg-emerald-500/10 text-emerald-400 border border-emerald-500/20">
                                                                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                                                                {language === 'ar' ? 'الآن' : 'Now'}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <h3 className="text-base font-black text-darktheme dark:text-white leading-snug mb-1 group-hover:text-gradient transition-colors duration-300">
                                                        {language === 'ar' ? item.arabicTitle : item.title}
                                                    </h3>
                                                    <AnimatePresence>
                                                        {isActive && (
                                                            <motion.p
                                                                initial={{ opacity: 0, height: 0 }}
                                                                animate={{ opacity: 1, height: 'auto' }}
                                                                exit={{ opacity: 0, height: 0 }}
                                                                transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                                                                className="text-xs text-gray-400 mt-2 overflow-hidden"
                                                                style={{ lineHeight: 1.7 }}
                                                            >
                                                                {language === 'ar' ? item.arabicDescription : item.description}
                                                            </motion.p>
                                                        )}
                                                    </AnimatePresence>
                                                    <motion.div
                                                        animate={{ rotate: isActive ? 180 : 0 }}
                                                        className="mt-3 flex"
                                                        style={{ justifyContent: language === 'ar' ? 'flex-end' : 'flex-start' }}
                                                    >
                                                        <Icon icon="lucide:chevron-down" className="text-gray-600 text-sm" />
                                                    </motion.div>
                                                </motion.div>
                                            )}
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </div>

                        {/* End cap */}
                        <div className="flex justify-center mt-8">
                            <div className="w-4 h-4 rounded-full" style={{ background: 'linear-gradient(135deg, #10b981, #06b6d4)', boxShadow: '0 0 20px rgba(16,185,129,0.5)' }} />
                        </div>
                    </div>
                </div>
            </div>


            {/* ── CONTACT BOTTOM CTA ────────────────────────────────────── */}
            <div className="max-w-6xl mx-auto px-4 md:px-10 lg:px-20 pb-20 md:pb-28">
                <motion.div
                    variants={fadeUp}
                    className="relative rounded-3xl overflow-hidden"
                    style={{
                        background: 'linear-gradient(135deg, #0d0d20, #12102a)',
                        border: '1px solid rgba(82,92,235,0.2)',
                        boxShadow: '0 30px 80px rgba(82,92,235,0.1)'
                    }}
                >
                    <div className="absolute -left-20 -top-20 w-64 h-64 rounded-full opacity-20 blur-3xl pointer-events-none"
                        style={{ background: 'radial-gradient(circle, #525ceb, transparent)' }} />
                    <div className="absolute -right-20 -bottom-20 w-64 h-64 rounded-full opacity-15 blur-3xl pointer-events-none"
                        style={{ background: 'radial-gradient(circle, #10b981, transparent)' }} />

                    <div className="relative z-10 py-14 px-8 md:py-20 md:px-16">
                        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
                            {/* Text */}
                            <div className="flex-1 text-center md:text-left">
                                <p className="text-[10px] font-black uppercase tracking-[0.2em] mb-3"
                                    style={{ color: '#525ceb' }}>
                                    {language === 'en' ? 'Get in Touch' : 'تواصل معي'}
                                </p>
                                <h2 className="text-3xl md:text-4xl font-black text-white mb-3 leading-tight">
                                    {language === 'en' ? (
                                        <>Let's build something <span className="text-gradient">amazing</span> together</>
                                    ) : 'دعنا نبني شيئاً مذهلاً معاً'}
                                </h2>
                                <p className="text-gray-400 text-sm md:text-base font-medium leading-relaxed max-w-md">
                                    {language === 'en'
                                        ? "Whether it's a website, a design, or a data project — I'm here to help you succeed."
                                        : 'سواء كان موقعًا إلكترونيًا أو تصميمًا أو مشروع بيانات — أنا هنا لمساعدتك على النجاح.'}
                                </p>
                            </div>

                            {/* Contact cards */}
                            <div className="flex flex-col gap-3 w-full md:w-auto md:min-w-[260px]">
                                {contacts.map((c, i) => (
                                    <Link key={i} to={c.href} target="_blank"
                                        className="flex items-center gap-3 px-5 py-3.5 rounded-2xl font-semibold text-sm transition-transform duration-200 hover:scale-[1.02] hover:-translate-y-0.5"
                                        style={{
                                            background: `${c.color}12`,
                                            border: `1px solid ${c.color}25`,
                                            color: c.color
                                        }}
                                        onMouseEnter={e => { e.currentTarget.style.background = `${c.color}25`; e.currentTarget.style.borderColor = `${c.color}50`; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = `${c.color}12`; e.currentTarget.style.borderColor = `${c.color}25`; }}
                                    >
                                        <Icon icon={c.icon} className="text-xl flex-shrink-0" />
                                        <div>
                                            <div className="text-[10px] font-black uppercase tracking-wider opacity-60">{c.label}</div>
                                            <div className="text-xs font-semibold text-white">{c.value}</div>
                                        </div>
                                        <Icon icon="lucide:external-link" className="text-xs ml-auto opacity-40" />
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </motion.div>
    );
};

export default About;
